<template lang="html">
	<table class="campaign-table-status-dates">
		<tbody>
			<tr
				v-for="(row, i) in scheduleText"
				:key="`scheduleText-${i}`"
			>
				<td v-if="row.error">{{ row.error }}</td>
				<component
					v-else
					v-for="(cell, key) in row"
					:key="key"
					:is="'label' === key ? 'th' : 'td'"
				>
					{{ cell }}
				</component>
			</tr>
		</tbody>
	</table>
</template>

<script lang="js">
import format from 'date-fns/format'
import { appData } from '@/utils'

/**
 * Campaign Rules Schedule
 * @displayName Campaign Rules Schedule
 * @since 2.0.0
 */
export default  {
	props : {
		/**
		 * Rules
		 */
		rules : {
			type : Array,
			default () {
				return []
			},
		},
	},
	computed : {
		rulesetData () {
			return appData.get('rulesetData')
		},
		/**
		 * The row data for schedule.
		 * @returns {Array} The array of row data for schedule.
		 */
		scheduleText () {
			let rules = []

			if (this.rules.length) {
				this.rules.forEach(data => {
					if ([ 'on-after', 'on-before' ].includes(data.operator)) {
						rules.push({
							label : 'on-after' === data.operator ? 'Start On:' : 'End On:',
							date  : format(new Date(data.value), 'MM/dd/yyyy h:mm a'),
							zone  : this.getScheduleUnit(data),
						})
					}
				})
			} else {
				rules.push({ error: 'No schedule rules found' })
			}

			return rules
		},
	},
	methods : {
		getScheduleUnit (data) {
			const obj = this.rulesetData.getItemObject(data)
			const unit = obj ? this.rulesetData.getItemUnit(data, obj) : false
			if (unit) {
				const parts = unit.split('(')
				return (parts[1] ? '(' + parts[1] : unit)
			}

			return ''
		},
	},
}
</script>

<style lang="scss">
	@import '../../assets/scss/variables';
	.omapi-table {
		.campaign-table-status {
			&-dates {
				border-collapse: collapse;

				th, td {
					font-weight: normal;
					text-align: left;
					font-size: 13px;
					color: $color_white;
					padding: 0 4px 0 0;
					white-space: nowrap;
				}
				td:last-child {
					padding-right: 0;
				}
				th {
					text-align: right;
				}
			}
		}
	}
</style>
